// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage  }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({

    id: '',
    port: '',
    portType: '',
    feeType: '',
    commodity: '',
    subCommodity: '',
    subSubCommodity: '',
    vessel: '',
    imoNumber: '',
    portOfRegistry: '',

    officialNumber: '',
    flag: '',
    coastal: '',
    dwt: '',
    grt: '',
    nrt: '',
    arrivalDate: '',
    commencementDate: '',
    departureDate: '',
    transhipment: '',

    lastPortCall: '',
    nextPortCall: '',
    completionDate: '',
    supportingDoc: '',
    rate: null,
    quantity: '',
    total: null,
    penaltyDays: null,
    penaltyAmount: null,
    penaltyTotal: null,

    grandTotal: null,
    tds: null,
    cgst: null,
    sgst: null,
    igst: null,
    finalAmount: null,
    paymentMode: '',
    paymentStatus: '',

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
    
  //*********************************** Fetch invoice data when the modal opens ********************************************************
  useEffect(() => {
    
    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');
        
        try {
          const response = await apiClient.get(`/api/admin/fee_collection_temp/${invoiceId}`);

          if(response.data.Status === "SUCCESS") {

          setFormData({
            id: invoiceId || '',
            port: response.data.data.port  || '',
            portType: response.data.data.portType || '',
            feeType: response.data.data.feeType || '',
            commodity: response.data.data.commodity || '',
            subCommodity: response.data.data.subCommodity || '',
            subSubCommodity: response.data.data.subSubCommodity || '',
            vessel: response.data.data.vessel || '',
            imoNumber: response.data.data.imoNumber || '',
            portOfRegistry: response.data.data.portOfRegistry || '',
            officialNumber: response.data.data.officialNumber || '',
            flag: response.data.data.flag || '',
            coastal: response.data.data.coastal || '',
            dwt: response.data.data.dwt || '',
            grt: response.data.data.grt || '',
            nrt: response.data.data.nrt || '',
            arrivalDate: response.data.data.arrivalDate || '',
            commencementDate: response.data.data.commencementDate || '',
            departureDate: response.data.data.departureDate || '',
            transhipment: response.data.data.transhipment || '',
            lastPortCall: response.data.data.lastPortCall || '',
            nextPortCall: response.data.data.nextPortCall || '',
            completionDate: response.data.data.completionDate || '',
            supportingDoc: response.data.data.supportingDoc || '',
            rate: response.data.data.rate || '',
            quantity: response.data.data.quantity || '',
            total: response.data.data.total || '',
            penaltyDays: response.data.data.penaltyDays || '',
            penaltyAmount: response.data.data.penaltyAmount || '',
            penaltyTotal: response.data.data.penaltyTotal || '',
            grandTotal: response.data.data.grandTotal || '',
            tds: response.data.data.tds || '',
            cgst: response.data.data.cgst || '',
            sgst: response.data.data.sgst || '',
            igst: response.data.data.igst || '',
            finalAmount: response.data.data.finalAmount || '',
            paymentMode: response.data.data.paymentMode || '',
            paymentStatus: response.data.data.paymentStatus || ''
          });
          }
            else{
              console.log(response.data.message)
            }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };
  
    fetchInvoiceData();
  }, [invoiceId, edit]);  


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');
  
    try {
      const response = await apiClient.put(`/api/admin/fee_collection_temp/update`, formData);
      if(response.data.Status === "SUCCESS") {
        
      }
        else{
          console.log(response.data.message)
        }  
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };
  
  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit fee_collection_temp
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className="spacing">
                    <label htmlFor="port" className="label-custom">Port</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="port"
                      name="port"
                      value={formData.port}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="portType" className="label-custom">Port Type </label>
                    <input
                      type="text"
                      className="input-custom"
                      id="portType"
                      name="portType"
                      value={formData.portType}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="feeType" className="label-custom">Fee Type</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="feeType"
                      name="feeType"
                      value={formData.feeType}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="commodity" className="label-custom">Commodity</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="commodity"
                      name="commodity"
                      value={formData.commodity}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="subCommodity" className="label-custom">Sub Commodity</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="subCommodity"
                      name="subCommodity"
                      value={formData.subCommodity}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="subSubCommodity" className="label-custom">Sub Sub Commodity</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="subSubCommodity"
                      name="subSubCommodity"
                      value={formData.subSubCommodity}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="vessel" className="label-custom">Vessel</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="vessel"
                      name="vessel"
                      value={formData.vessel}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="imoNumber" className="label-custom">IMO Number</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="imoNumber"
                      name="imoNumber"
                      value={formData.imoNumber}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="portOfRegistry" className="label-custom">Port Of Registry</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="portOfRegistry"
                      name="portOfRegistry"
                      value={formData.portOfRegistry}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="officialNumber" className="label-custom">Official Number</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="officialNumber"
                      name="officialNumber"
                      value={formData.officialNumber}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="flag" className="label-custom">Flag</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="flag"
                      name="flag"
                      value={formData.flag}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="coastal" className="label-custom">Coastal</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="coastal"
                      name="coastal"
                      value={formData.coastal}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="dwt" className="label-custom">DWT</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="dwt"
                      name="dwt"
                      value={formData.dwt}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="grt" className="label-custom">GRT</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="grt"
                      name="grt"
                      value={formData.grt}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="nrt" className="label-custom">NRT</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="nrt"
                      name="nrt"
                      value={formData.nrt}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="arrivalDate" className="label-custom">Arrival Date</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="arrivalDate"
                      name="arrivalDate"
                      value={formData.arrivalDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="commencementDate" className="label-custom">Commencement Date</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="commencementDate"
                      name="commencementDate"
                      value={formData.commencementDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="departureDate" className="label-custom">Departure Date</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="departureDate"
                      name="departureDate"
                      value={formData.departureDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="transhipment" className="label-custom">Transhipment</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="transhipment"
                      name="transhipment"
                      value={formData.transhipment}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="lastPortCall" className="label-custom">Last Port Call</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="lastPortCall"
                      name="lastPortCall"
                      value={formData.lastPortCall}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="nextPortCall" className="label-custom">Next Port Call</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="nextPortCall"
                      name="nextPortCall"
                      value={formData.nextPortCall}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="completionDate" className="label-custom">Completion Date</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="completionDate"
                      name="completionDate"
                      value={formData.completionDate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="supportingDoc" className="label-custom">Supporting Doc</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="supportingDoc"
                      name="supportingDoc"
                      value={formData.supportingDoc}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="rate" className="label-custom">Rate</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="rate"
                      name="rate"
                      value={formData.rate}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="quantity" className="label-custom">Quantity</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="quantity"
                      name="quantity"
                      value={formData.quantity}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="total" className="label-custom">Total</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="total"
                      name="total"
                      value={formData.total}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="penaltyDays" className="label-custom">Penalty Days</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="penaltyDays"
                      name="penaltyDays"
                      value={formData.penaltyDays}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="penaltyAmount" className="label-custom">Penalty Amount</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="penaltyAmount"
                      name="penaltyAmount"
                      value={formData.penaltyAmount}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="penaltyTotal" className="label-custom">Penalty Total</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="penaltyTotal"
                      name="penaltyTotal"
                      value={formData.penaltyTotal}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="grandTotal" className="label-custom">Grand Total</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="grandTotal"
                      name="grandTotal"
                      value={formData.grandTotal}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="tds" className="label-custom">TDS</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="tds"
                      name="tds"
                      value={formData.tds}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="cgst" className="label-custom">CGST</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="cgst"
                      name="cgst"
                      value={formData.cgst}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="sgst" className="label-custom">SGST</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="sgst"
                      name="sgst"
                      value={formData.sgst}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="igst" className="label-custom">IGST</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="igst"
                      name="igst"
                      value={formData.igst}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="finalAmount" className="label-custom">Final Amount</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="finalAmount"
                      name="finalAmount"
                      value={formData.finalAmount}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="paymentMode" className="label-custom">Payment Mode</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="paymentMode"
                      name="paymentMode"
                      value={formData.paymentMode}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing">
                    <label htmlFor="paymentStatus" className="label-custom">Payment Status</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="paymentStatus"
                      name="paymentStatus"
                      value={formData.paymentStatus}
                      onChange={handleChange}
                    />
                  </div>


                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
